import { AddressScreen } from '../features/checkout/AddressScreen'

export function CheckoutAddressPage() {
  return <AddressScreen />
}
